import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";

import { ApiService } from "./api.service";

@Injectable()
export class UserService {
  userList;
  updateUserEvent: Subject<void> = new Subject<void>();
  private subject = new Subject<any>();
  isCompleteFirstFlow = false;

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) {}

  public isAdmin() {
    const tmp = JSON.parse(localStorage.getItem("user"));
    return tmp.role === "admin" || tmp.role === "amlco-officer";
  }

  public isAMLCOOfficer() {
    const tmp = JSON.parse(localStorage.getItem("user"));
    return tmp.role === "amlco-officer";
  }

  /**
   * Users who may look at everything their labels cover but change nothing. The backend refuses
   * their writes outright; this only keeps the panel from offering actions that cannot succeed.
   */
  public isReadOnly() {
    const tmp = JSON.parse(localStorage.getItem("user"));
    return tmp?.role === "read-only-user";
  }

  async updateUser(user, id: string) {
    return await this.apiService.put(`user/${id}`, user);
  }

  getUserId() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) return user._id;
    else return "";
  }

  getUser(id: string) {
    return this.apiService.get(`user/${id}`);
  }

  getAllUsers() {
    return this.apiService.get(`user/all`);
  }

  changePassword(data) {
    return this.apiService.put(`user/change-password`, data);
  }

  getFirmStatus() {
    return this.apiService.get(`firm/status`);
  }
}
